import { useState } from "react"
import { Stack, Typography, CircularProgress } from "@mui/material"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { ScenarioPromotionProgress } from "routes/scenarios/scenario-promotion-event-definitions.mjs"

/**
 * Content of the persistent snackbar shown while a scenario promotion runs in the background.
 * Subscribes to ScenarioPromotionProgress for its scenario and updates the phase message live.
 *
 * @param {{ scenarioId: string, regimeName?: string }} props
 */
export function ScenarioPromotionSnackbar({ scenarioId, regimeName }) {
    const [message, setMessage] = useState(null)
    ScenarioPromotionProgress.useEvent(onProgress, [scenarioId])

    return (
        <Stack direction="row" spacing={1.5} alignItems="center">
            <CircularProgress size={18} color="inherit" />
            <Stack spacing={0}>
                <Typography variant="body2">Promoting {regimeName ?? "scenario"} to a draft regime…</Typography>
                <If value={message}>
                    <Typography variant="caption" sx={{ opacity: 0.85 }}>
                        {message}
                    </Typography>
                    <Else>
                        <Typography variant="caption" sx={{ opacity: 0.85 }}>
                            Running in the background — this can take a few minutes for large regimes.
                        </Typography>
                    </Else>
                </If>
            </Stack>
        </Stack>
    )

    function onProgress(payload) {
        if (!payload || payload.scenarioId !== scenarioId) return
        setMessage(payload.message)
    }
}
